import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let auth = localStorage.auth ? JSON.parse(localStorage.auth) : null;

const setHTMLClass = (className: string, add = true): void => {
  if (add) {
    if (!document.documentElement.classList.contains(className)) {
      document.documentElement.classList.add(className);
    }
  } else {
    if (document.documentElement.classList.contains(className)) {
      document.documentElement.classList.remove(className);
    }
  }
};

export default new Vuex.Store({
  state: {
    /* User */
    userName: null,
    userEmail: null,
    userAvatar: null,

    /* NavBar */
    isNavBarVisible: true,
    breadcrumbs: [],

    /* FooterBar */
    isFooterBarVisible: true,

    /* Aside */
    isAsideVisible: true,
    isAsideExpanded: true,
    isAsideMobileExpanded: false,
    asideActiveForcedKey: null,
    isAsideRightVisible: false,

    /* Updates */
    hasUpdates: false,

    /* Overlay */
    isOverlayVisible: false,

    /* Authentication */
    auth: auth,

    /* Tenants */
    tenants: [],

    /* Content */
    contents: {},

    /* Users */
    users: {}
  },
  mutations: {
    /* A fit-them-all commit */
    basic(state: any, payload: any) {
      state[payload.key] = payload.value;
    },

    /* Adds content */
    setContent(state: any, payload: any) {
      state.contents[payload.id] = payload.content;
    },

    /* Adds content */
    setUser(state: any, payload: any) {
      state.users[payload.id] = payload.user;
    },

    /* Breadcrumbs */
    clearBreadcrumbs(state: any, payload: any) {
      state.breadcrumbs = [];
    },

    pushBreadcrumbs(state: any, payload: any) {
      state.breadcrumbs.push(payload);
    },

    popBreadcrumbs(state: any, payload: any) {
      if (state.breadcrumbs.length) {
        state.breadcrumbs.pop();
      }
    },

    /* Authentication */
    login(state: any, payload: any) {
      state.auth = payload;

      if (payload.name) {
        state.userName = payload.name;
      }
      if (payload.email) {
        state.userEmail = payload.email;
      }
    },

    /* Authentication */
    logout(state: any, payload: any) {
      state.auth = {};
      state.userName = "";
      state.userEmail = "";
      localStorage.removeItem("user");
    },

    refreshLogin(state: any, payload: any) {
      state.auth.jwts = payload;
    },

    /* User */
    user(state: any, payload: any) {
      console.log("User deprecated");
      if (payload.name) {
        state.userName = payload.name;
      }
      if (payload.email) {
        state.userEmail = payload.email;
      }
      if (payload.avatar) {
        state.userAvatar = payload.avatar;
      }
    },

    /* Full Page mode */
    fullPage(state: any, payload: any) {
      state.isNavBarVisible = !payload;
      state.isAsideVisible = !payload;
      state.isFooterBarVisible = !payload;

      ["has-aside-left", "has-navbar-fixed-top"].forEach(
        (htmlClass: string) => {
          setHTMLClass(htmlClass, !payload);
        }
      );

      // Set full-screen background
      setHTMLClass("site-background", payload);
    },

    /* Aside Desktop */
    asideStateToggle(state: any, payload = null) {
      const htmlAsideClassName = "has-aside-expanded";

      let isExpand;

      if (payload !== null) {
        isExpand = payload;
      } else {
        isExpand = !state.isAsideExpanded;
      }

      if (isExpand) {
        document.documentElement.classList.add(htmlAsideClassName);
      } else {
        document.documentElement.classList.remove(htmlAsideClassName);
      }

      state.isAsideExpanded = isExpand;
    },

    /* Aside Mobile */
    asideMobileStateToggle(state: any, payload = null) {
      const htmlClassName = "has-aside-mobile-expanded";

      let isShow;

      if (payload !== null) {
        isShow = payload;
      } else {
        isShow = !state.isAsideMobileExpanded;
      }

      if (isShow) {
        document.documentElement.classList.add(htmlClassName);
      } else {
        document.documentElement.classList.remove(htmlClassName);
      }

      state.isAsideMobileExpanded = isShow;
    },

    /* Aside Forced Active Key (when secondary submenu is open) */
    asideActiveForcedKeyToggle(state: any, payload: any) {
      state.asideActiveForcedKey =
        payload && payload.menuSecondaryKey ? payload.menuSecondaryKey : null;
    },

    /* Aside Right */
    asideRightToggle(state: any, payload = null) {
      const htmlClassName = "has-aside-right";

      let isShow;

      if (payload !== null) {
        isShow = payload;
      } else {
        isShow = !state.isAsideRightVisible;
      }

      if (isShow) {
        document.documentElement.classList.add(htmlClassName);
      } else {
        document.documentElement.classList.remove(htmlClassName);
      }

      state.isAsideRightVisible = isShow;
      state.hasUpdates = false;
    },

    /* Overlay */
    overlayToggle(state: any, payload = null) {
      if (payload === null) {
        payload = !state.isOverlayVisible;
      }

      state.isOverlayVisible = !!payload;
    }
  },
  actions: {},
  getters: {},
  modules: {}
});
